import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={40} height={40} rx={20} fill={props.bgColor || "white"} />
    <Path
      d="M11.5 29C11.1 29 10.75 28.85 10.45 28.55C10.15 28.25 10 27.9 10 27.5V14.5C10 14.1 10.15 13.75 10.45 13.45C10.75 13.15 11.1 13 11.5 13H28.5C28.9 13 29.25 13.15 29.55 13.45C29.85 13.75 30 14.1 30 14.5V27.5C30 27.9 29.85 28.25 29.55 28.55C29.25 28.85 28.9 29 28.5 29H11.5ZM28.5 15.875L20.4 21.175C20.3333 21.2083 20.2708 21.2375 20.2125 21.2625C20.1542 21.2875 20.0833 21.3 20 21.3C19.9167 21.3 19.8458 21.2875 19.7875 21.2625C19.7292 21.2375 19.6667 21.2083 19.6 21.175L11.5 15.875V27.5H28.5V15.875ZM20 19.95L28.4 14.5H11.625L20 19.95ZM11.5 16.05V15.0625V15.075V15.05V16.05Z"
      fill={props.color || "#00813B"}
    />
    <Path
      d="M28.5 27.5V15.875L20.4004 21.1748L20.2129 21.2627L20.1152 21.291C20.0799 21.2972 20.0415 21.2998 20 21.2998C19.9585 21.2998 19.9201 21.2972 19.8848 21.291L19.7871 21.2627C19.7289 21.2377 19.6662 21.2081 19.5996 21.1748L11.5 15.875V27.5H28.5ZM20 19.9502L28.4004 14.5H11.625L20 19.9502ZM30 27.5C30 27.9 29.8498 28.2498 29.5498 28.5498C29.2498 28.8498 28.9 29 28.5 29H11.5C11.1499 29 10.838 28.8851 10.5645 28.6553L10.4502 28.5498C10.1502 28.2498 10 27.9 10 27.5V14.5C10 14.1499 10.1149 13.838 10.3447 13.5645L10.4502 13.4502C10.7502 13.1502 11.1 13 11.5 13H28.5C28.9 13 29.2498 13.1502 29.5498 13.4502C29.8498 13.7502 30 14.1 30 14.5V27.5Z"
      fill={props.color || "#00813B"}
    />
  </Svg>
);
export default SVGComponent;
